import { Button, ComboBox, IconButton, Label, MessageBar, MessageBarType, Pivot, PivotItem, PrimaryButton, ProgressIndicator, Stack, Text, TextField } from '@fluentui/react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { IEvent } from '../../../Models/Event/IEvent';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IOrder } from '../../../Models/Order/IOrder';
import { EmptyProfileContact, IProfileContact } from '../../../Models/Profile/IProfileContact';
import { IUserProfile } from '../../../Models/Profile/IUserProfile';
import { validateEmail } from '../../../Tools/Validation';
import { InvoiceContact } from '../../Identity/InvoiceContact/InvoiceContact';
import { InvoiceContactForm } from '../../Identity/InvoiceContact/InvoiceContactForm';
import { InvoiceContactView } from '../../Identity/InvoiceContact/InvoiceContactView';
import { PageTitle } from '../../PageTitle';
import { NewOrderConfirmation } from './NewOrderConfirmation';
import { NewOrderRecap } from './NewOrderRecap';
import { NewOrderStepAttendee } from './NewOrderStepAttendee';
import { NewOrderStepEmail } from './NewOrderStepEmail';
import { NewOrderStepEvent } from './NewOrderStepEvent';
import { NewOrderStepInvoice } from './NewOrderStepInvoice';
import { NewOrderStepOtherInformation } from './NewOrderStepOtherInformation';
import { NewOrderSteps } from './NewOrderSteps'

interface INewOrderViewProps {
    userId: string;
    isAuth: boolean;
    event?: IEvent;
    profileInfo: IProfileContact;
    email: string;
    emailChanged: (email: string) => void;
    checkEmail: (mail: string) => void;
    emailExists?: boolean;
    step: number;
    goToStep: (step: number) => void;
    goBack: () => void;
    invoiceContantpropertyChanged: (key: string, value: any) => void;
    isLoading: boolean;
    addAttendee: (item: IAttendee) => void;
    attendees: IAttendee[];
    selectAttendee: (item: IAttendee) => void;
    attendeesSelected: IAttendee[];
    removeSelectedAttendee: (id: number, userId: string) => void;
    finishOrder: () => void;
    emailChecked: boolean;
    smallScreen: boolean;
    middleScreen: boolean;
    order?: IOrder;
    statusMessage?: IStatusMessage;
    acceptPromotion: boolean;
    acceptMarketing: boolean;
    setAcceptPromotion: (value: boolean) => void;
    setAcceptMarketing: (value: boolean) => void;
    updateDoprovodAttendee: (id: number, value: string) => void;
}


export const NewOrderView: React.FunctionComponent<INewOrderViewProps> = (props) => {

    
    const location = useLocation();
   
    const renderEvent = () => {
        return (<NewOrderStepEvent isAuth={props.isAuth} goToStep={props.goToStep} event={props.event} />)
    }

    const renderEmail = () => {
        return (<NewOrderStepEmail
            emailChecked={props.emailChecked}
            isAuth={props.isAuth}
            goToStep={props.goToStep}
            checkEmail={props.checkEmail}
            email={props.email}
            emailChanged={props.emailChanged}
            emailExists={props.emailExists}
            goBack={props.goBack}
        />)
    }

    const renderInvoiceContact = () => {
        return (<NewOrderStepInvoice
            isAuth={props.isAuth} goToStep={props.goToStep}
            profileInfo={props.profileInfo}
            propertyChanged={props.invoiceContantpropertyChanged}
            goBack={props.goBack}
            isLoading={props.isLoading}
        />)
    }
    const renderAttendee = () => {
        return <NewOrderStepAttendee
            profileContact={props.profileInfo}
            userId={props.userId}
            isAuth={props.isAuth}
            goToStep={props.goToStep}
            goBack={props.goBack}
            attendees={props.attendees}
            addAttendee={props.addAttendee}
            selectAttendee={props.selectAttendee}
            attendeesSelected={props.attendeesSelected}
            removeSelectedAttendee={props.removeSelectedAttendee}
            event={props.event}
            email={props.email}
        />
    }
    const renderRekapitulace = () => {
        return <Stack>
            {props.event && props.profileInfo ?
                <NewOrderRecap
                    isLoading={props.isLoading}
                    email={props.email}
                    event={props.event}
                    isAuth={props.isAuth}
                    goToStep={props.goToStep}
                    finishOrder={props.finishOrder}
                    goBack={props.goBack}
                    profileInfo={props.profileInfo}
                    selectedAttendees={props.attendeesSelected}
                /> : null}
        </Stack>
    }

    const renderOtherInfo = () => {
        return <Stack>
            <NewOrderStepOtherInformation attendees={props.attendeesSelected}
                goToStep={props.goToStep}
                goBack={props.goBack}
                isAuth={props.isAuth}
                acceptMarketing={props.acceptMarketing}
                acceptPromotion={props.acceptPromotion}
                setAcceptMarketing={props.setAcceptMarketing}
                setAcceptPromotion={props.setAcceptPromotion}
                updateDoprovodAttendee={props.updateDoprovodAttendee}

            />
            </Stack>

    }

    const renderConfirmation = () =>
    {
        return <NewOrderConfirmation isAuth={props.isAuth} order={props.order} event={props.event} />
    }

    const renderSteps = (step: number) => {

        switch (step) {
            case 1: return renderEvent()
            case 2: return renderEmail()
            case 3: return renderInvoiceContact()
            case 4: return renderAttendee()
            case 5: return renderOtherInfo()
            case 6: return renderRekapitulace()
            case 7: return renderConfirmation()
            default: return <div>step</div>;
        }
    }

    return (<Stack styles={{ }}>
        <PageTitle title="Objednávka kurzu" />
        <Stack horizontalAlign="center" styles={{ root: { paddingTop: 40 } }} >
            <Stack styles={{ root: { paddingBottom: 10 } }} >
                <NewOrderSteps middleScreen={props.middleScreen} smallScreen={props.smallScreen} step={props.step} isAuth={props.isAuth} />
            </Stack>
            <Stack styles={{
                root: {
                    display: 'block',
                    width: '100%', maxWidth: 800,
                    paddingTop: 5,
                    paddingBottom: 35,
                    height:10,
                    paddingLeft: props.smallScreen ? 5 : 40,
                    paddingRight: props.smallScreen ? 5 : 40
                }
            }}>
                {props.isLoading ?
                    <ProgressIndicator />
                    : null
                }
                 
            </Stack> 
                <Stack horizontalAlign="center"
                styles={{
                    root: {
                        position: 'relative', boxShadow: '2px 2px 10px  lightgray',
                        padding: props.smallScreen ? 15 : 40,
                        paddingLeft: props.smallScreen ? 5 : 40,
                        paddingRight: props.smallScreen ? 5 : 40, display: 'block', width: '100%', maxWidth: 600, borderColor: 'white', borderWidth: 1, borderRadius: 10, borderStyle: 'solid'
                    }
                }}>

                
                  {renderSteps(props.step)}
                {!props.smallScreen ? <img style={{ position: 'absolute', bottom: 10, right: 10 }} src="/img/tuzka.png" /> : null}
                {props.statusMessage && props.statusMessage.message!=="" ?
                    <Stack styles={{ root: { paddingTop: 20, paddingRight:20 } }} >
                        <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar>
                    </Stack>
                    : null
                }
            </Stack>           
        </Stack>
        

    </Stack>
    );
}

